export default __webpack_public_path__ + "static/media/mamut_background_l2.2b9855e0.jpg";